module.exports = __webpack_public_path__ + "static/img/gpt25.4754d45d.png";